import { render, staticRenderFns } from "./ProductCardPageLeft.vue?vue&type=template&id=31ebd101&"
import script from "./ProductCardPageLeft.vue?vue&type=script&lang=js&"
export * from "./ProductCardPageLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports